module.exports = __webpack_public_path__ + "media/images/design/images/dantai/btn_canpan-6ef07bef5c3664bdf39f8575de0f2718.jpg";